import Navbar from "../components/Navbar";
import Chapter4thongtin from "./Chapter4thongtin";
function Chapter4(){
    return(
        <>
        <Navbar/>
        <Chapter4thongtin/>
        </>
    )
}
export default Chapter4;